
import { useState, useEffect } from 'react';
import { logger } from '@/utils/logger';
import { toast } from 'sonner';

export const useErrorNotification = (activeTab: string, setActiveTabFn: (tab: string) => void) => {
  const [recentErrors, setRecentErrors] = useState(logger.getRecentErrors());
  
  useEffect(() => {
    const interval = setInterval(() => {
      const errors = logger.getRecentErrors();
      setRecentErrors(errors);
      
      if (errors.length > recentErrors.length && activeTab !== 'errors') {
        const newCount = errors.length - recentErrors.length;
        toast.warning(`${newCount} new error${newCount > 1 ? 's' : ''} logged`, {
          action: {
            label: 'View',
            onClick: () => setActiveTabFn('errors')
          }
        });
      }
    }, 15000);

    return () => clearInterval(interval);
  }, [recentErrors.length, activeTab, setActiveTabFn]);

  const handleClearErrors = () => {
    logger.clearErrors();
    setRecentErrors([]);
    toast.success('Error logs cleared');
  };

  return { recentErrors, handleClearErrors };
};
